@if(isMaintenance)
{   
    <div class="d-flex flex-column justify-content-center align-items-center bold p-5 bg-dark"  style="margin:30vh 5rem 0 5rem; border-radius: 10px;">
        <p class="text-center" [innerHTML]="maintenanceText | safeHtml"></p>
    </div>
}
@else
{
    <app-alert></app-alert>
    @if(displayForm)
    {
        <router-outlet></router-outlet>
    }
}